export default `
fragment ParagraphButton on ParagraphButton {
  id
  uuid
  entityBundle
  linkType {
    entity {
      name
      token
      icon {
        entity {
          name
          media {
            entity {
              ...Media
            }
          }
        }
      }
    }
  }
  link {
    title
    url {
      path
    }
  }
}
`